import { EntityManager } from "@/components/EntityManager";
import { STATES } from "@/constants/options";

export default function Locations() {
  const columns = [
    { key: "name", label: "Name" },
    { key: "city", label: "City" },
    { key: "state", label: "State" },
    { key: "lat", label: "Lat", align: "right" },
    { key: "lng", label: "Lng", align: "right" },
  ];
  const fields = [
    { label: "Name", field: "name", placeholder: "e.g. Laydown Yard" },
    { label: "Address", field: "address", span: 2 },
    { label: "City", field: "city" },
    { label: "State", field: "state", type: "select", options: STATES },
    { label: "Latitude", field: "lat", type: "number", placeholder: "33.5779" },
    { label: "Longitude", field: "lng", type: "number", placeholder: "-101.8552" },
    { label: "Notes", field: "notes", type: "textarea", span: 2 },
  ];
  return (
    <EntityManager collection="locations" title="Locations"
      subtitle="Saved yards & sites with coordinates for reliable distance calculation"
      columns={columns} fields={fields} />
  );
}
